import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { API, get } from "../../../../config";

export const getBuilderDetail = async (builderId) => {
  try {
    const { data } = await get(`${API.BUILDER_DETAILS}/` + builderId);
    return data.data;
  } catch (e) {
    return null;
  }
};

export const getBuilderPopupDetail = async (builderId, isRecentActivity) => {
  try {
    if (isRecentActivity) {
      const { data } = await get(`${API.BUILDER_DETAILS}/${builderId}`);
      return data.data;
    } else {
      const { data } = await get(`${API.BUILDER_DETAILS}/${builderId}`);
      return data.data;
    }
  } catch (error) {
    if (error?.response?.data?.errors) {
      Object.keys(error?.response?.data?.errors).forEach((key) => {
        toast.error(error?.response?.data?.errors[key][0]);
      });
    } else {
      toast.error(error?.message);
    }
    return null;
  }
};

export const useStateList = () => {
  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setStateLoading(true);
      const { data } = await get(API.GET_STATE_LIST);
      setStateLoading(false);
      setStateList(data.data);
    } catch (e) {
      setStateList([]);
      setStateLoading(false);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return {
    stateList,
    stateLoading,
  };
};
